/**
 * 6 seed prompts shown on the empty state. Each one targets a question
 * Drishti can answer from drishti.md v0.1 — no traps, no out-of-scope bait.
 *
 * Chosen to cover the answer archetypes:
 *   - ranking (bad CMPs)
 *   - aggregate count (2X KM zone-wide)
 *   - narrative why (score collapse)
 *   - comparison (circle vs circle)
 *   - filter (Jammu drill-down)
 *   - ranking top (best billing)
 */

const starterPrompts = [
  {
    id: 'bad-cmps',
    label: 'Which CMPs are performing bad this month?',
    archetype: 'ranking',
  },
  {
    id: 'zone-2x',
    label: 'How many KM are at 2X risk across the zone?',
    archetype: 'aggregate',
  },
  {
    id: 'feb-collapse',
    label: "What's driving the Feb score collapse?",
    archetype: 'narrative',
  },
  {
    id: 'tower-exec',
    label: 'How is Tower performance looking?',
    archetype: 'aggregate',
  },
  {
    id: 'manpower-top',
    label: 'Which MPs drive the largest manpower penalties?',
    archetype: 'ranking',
  },
  {
    id: 'dec-waterfall',
    label: 'Show the Dec 2025 payout waterfall',
    archetype: 'aggregate',
  },
];

export default starterPrompts;
